module.exports = __webpack_public_path__ + "media/components/country-flag/static/gg-06491a1c39d0495636ccf774a462a819.svg";